<ddv-view-dashboard-note-button
    [label]="note.buttonLabel"
    (pressed)="showModal = true"
>
</ddv-view-dashboard-note-button>

@if (showModal) {
    <ddv-dashboard-note
        ccModal
        [note]="note"
        (acknowledge)="showModal = false"
    >
    </ddv-dashboard-note>
}
